import { toast } from '@heidi/design-system/toast';
import type { IntlShape } from 'react-intl';

/** Success toast after staging attachments (errors still use mergePickedFiles.error). */
export const toastAttachmentStaging = (
  intl: IntlShape,
  previousCount: number,
  nextCount: number,
  hadError: boolean
): void => {
  const addedCount = nextCount - previousCount;
  if (addedCount <= 0) return;

  const title = intl.formatMessage(
    {
      defaultMessage:
        '{addedCount, plural, one {# file attached} other {# files attached}}',
      id: 'cUx7WMzGce',
    },
    { addedCount }
  );

  const description =
    nextCount === 1
      ? hadError
        ? intl.formatMessage({
            defaultMessage: 'Some files were skipped',
            id: 'r/9L/1KlID',
          })
        : intl.formatMessage({
            defaultMessage: 'Ready to send with your message',
            id: '5hB5oYSb70',
          })
      : hadError
        ? intl.formatMessage(
            {
              defaultMessage:
                '{nextCount, plural, one {# file staged — some were skipped} other {# files staged — some were skipped}}',
              id: 'gL+vegbKrc',
            },
            { nextCount }
          )
        : intl.formatMessage(
            {
              defaultMessage:
                '{nextCount, plural, one {# file staged} other {# files staged}}',
              id: '7w5qPAt/hz',
            },
            { nextCount }
          );

  toast({ title, description });
};
